import { Header } from '@/components/Header';
import { TopBar } from '@/components/TopBar';
import { Footer } from '@/components/Footer';
import { HreflangTags } from '@/components/HreflangTags';
import { HeroSection } from '@/components/sections/HeroSection';
import { SolutionsSection } from '@/components/sections/SolutionsSection';
import { SpecializedSolutions } from '@/components/sections/SpecializedSolutions';
import { TektelicSection } from '@/components/sections/TektelicSection';
import { ViziosenseSection } from '@/components/sections/ViziosenseSection';
import { ConnectivitySection } from '@/components/sections/ConnectivitySection';
import { DeviceEcosystem } from '@/components/sections/DeviceEcosystem';
import { CustomersSection } from '@/components/sections/CustomersSection';
import { TestimonialsSection } from '@/components/sections/TestimonialsSection';
import { DeploymentsSection } from '@/components/sections/DeploymentsSection';
import { OpenPlatformsSection } from '@/components/sections/OpenPlatformsSection';
import { ConsultingSection } from '@/components/sections/ConsultingSection';
import { InfrastructureSection } from '@/components/sections/InfrastructureSection';
import { CTASection } from '@/components/sections/CTASection';
import { ContactForm } from '@/components/sections/ContactForm';
import { Helmet } from 'react-helmet-async';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>0g Baltics | IoT Infrastructure and Smart Solutions for the Baltics</title>
        <meta name="description" content="0g Baltics helps cities, utilities and companies deploy IoT infrastructure that reduces operational costs. LoRaWAN, Sigfox, NB-IoT solutions across Lithuania, Latvia, Estonia." />
        <meta name="keywords" content="IoT solutions Baltics, LoRaWAN infrastructure Baltics, Tektelic gateways Europe, IoT asset tracking solutions, smart metering infrastructure, smart locker systems, indoor air quality monitoring, IoT infrastructure for cities, smart building IoT solutions, industrial IoT consulting" />
        <link rel="canonical" href="https://0gbaltics.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://0gbaltics.com/" />
        <meta property="og:title" content="0g Baltics | IoT Infrastructure and Smart Solutions for the Baltics" />
        <meta property="og:description" content="We help cities, utilities and companies deploy IoT infrastructure that reduces operational costs." />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/c3a67mbc_0g%20Baltics_SSb-R00a_Mil.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://0gbaltics.com/" />
        <meta property="twitter:title" content="0g Baltics | IoT Infrastructure and Smart Solutions for the Baltics" />
        <meta property="twitter:description" content="We help cities, utilities and companies deploy IoT infrastructure that reduces operational costs." />
      </Helmet>
      <HreflangTags />
      
      {/* Static TopBar - visible at page top */}
      <TopBar />
      
      {/* Sticky Header - appears on scroll */}
      <Header />
      
      <main>
        {/* Section 1: Hero */}
        <HeroSection />
        
        {/* Section 2: IoT Solutions Grid */}
        <SolutionsSection />
        
        {/* Section 2b: Specialized IoT Solutions (0g Baltics Products) */}
        <SpecializedSolutions />
        
        {/* Section 3: Tektelic / LoRaWAN Infrastructure */}
        <TektelicSection />
        
        {/* Section 4: Viziosense / Occupancy Intelligence */}
        <ViziosenseSection />
        
        {/* Section 5: Multi-Network Connectivity */}
        <ConnectivitySection />
        
        {/* Section 6: Device Ecosystem / Partners */}
        <DeviceEcosystem />
        
        {/* Section 6b: Our Customers */}
        <CustomersSection />

        {/* Client Testimonials */}
        <TestimonialsSection />
        
        {/* Section 7: Deployments / Use Cases */}
        <DeploymentsSection />
        
        {/* Section 8: Open IoT Platforms */}
        <OpenPlatformsSection />
        
        {/* Section 9: Cost Reduction Consulting */}
        <ConsultingSection />
        
        {/* Section 10: Baltics Infrastructure */}
        <InfrastructureSection />
        
        {/* Section 11: CTA */}
        <CTASection />
        
        {/* Contact Form */}
        <ContactForm />
      </main>
      
      <Footer />
    </div>
  );
}
